import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/resources/images/logo/logo-hys@3x.png",
  alt: "新創築夢資源網",
  width: "187",
  height: "39"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav ms-auto" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, "新創計畫", -1)
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "AIoT 加速器", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "AIoT 加速器", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "青創基地", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "青創基地", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "社創基地", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "社創基地", -1)
const _hoisted_18 = { class: "nav-item dropdown" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, "資源搜尋", -1)
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "政府資源總覽", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "政府資源總覽", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "資金快搜", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "資金快搜", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "新創夥伴快搜", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "新創夥伴快搜", -1)
const _hoisted_27 = { class: "nav-item dropdown" }
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "創業新訊", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "創業新訊", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "近期活動", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "近期活動", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "亮點成果", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "亮點成果", -1)
const _hoisted_35 = { class: "nav-item dropdown" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " 創業工具 ", -1)
const _hoisted_37 = { class: "dropdown-menu" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://exam.taiwanjobs.gov.tw/JobExam/",
    class: "dropdown-item",
    title: "另開新視窗",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "d-xl-none",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false"
    }, "創業診斷"),
    /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "創業診斷")
  ])
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "創業Q&A", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "創業Q&A", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-xl-none",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, "預約諮詢", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-xl-block" }, "預約諮詢", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("button", {
  class: "icon-search",
  type: "submit",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Search")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "btn-top" }, null, -1)
const _hoisted_46 = { class: "container" }
const _hoisted_47 = { class: "row footer-top" }
const _hoisted_48 = { class: "col frss d-md-flex d-none" }
const _hoisted_49 = { class: "d-grid w-100" }
const _hoisted_50 = { class: "g-col-md-4 mb-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "head mb-2 d-flex" }, "關於我們", -1)
const _hoisted_52 = { class: "nav flex-column" }
const _hoisted_53 = { class: "nav-item mb-2" }
const _hoisted_54 = { class: "nav-item mb-2" }
const _hoisted_55 = { class: "g-col-md-4 mb-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "head mb-2 d-flex" }, "資源搜尋", -1)
const _hoisted_57 = { class: "nav flex-column" }
const _hoisted_58 = { class: "nav-item mb-2" }
const _hoisted_59 = { class: "nav-item mb-2" }
const _hoisted_60 = { class: "nav-item mb-2" }
const _hoisted_61 = { class: "nav-item mb-2" }
const _hoisted_62 = { class: "nav-item mb-2" }
const _hoisted_63 = { class: "g-col-md-4 mb-3" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "head mb-2 d-flex" }, "活動消息", -1)
const _hoisted_65 = { class: "nav flex-column" }
const _hoisted_66 = { class: "nav-item mb-2" }
const _hoisted_67 = { class: "nav-item mb-2" }
const _hoisted_68 = { class: "nav-item mb-2" }
const _hoisted_69 = { class: "g-col-md-4 mb-3" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "head mb-2 d-flex" }, "創業工具", -1)
const _hoisted_71 = { class: "nav flex-column" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item mb-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://exam.taiwanjobs.gov.tw/JobExam/",
    class: "nav-link p-0",
    title: "另開新視窗",
    target: "_blank"
  }, "創業診斷")
], -1)
const _hoisted_73 = { class: "nav-item mb-2" }
const _hoisted_74 = { class: "nav-item mb-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 主辦單位：新竹縣政府教育局"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 本網站之圖片、文章等內容，屬著作權人擁有，任何人未經授權同意，不得以任何形式予以利用、使用、轉載、散布、出版或傳播，違者依法追究責任。 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 為提供使用者有文書軟體選擇的權利，本網站文件為ODF開放文件格式，建議您安裝免費開源軟體(免費開源軟體LibreOffice下載) 或以您慣用的軟體開啟文件。 ")
    ])
  ])
], -1)
const _hoisted_76 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-bottom frcb\"><a class=\"footer-bottom-item navbar-brand d-flex p-0 mx-lg-0 mx-auto\" href=\"#\"><img src=\"resources/images/logo/logo-hys_white@3x.png\" alt=\"新創築夢資源網\" width=\"246\" height=\"50\"></a><div class=\"footer-bottom-item fccs align-items-lg-start\"><div> 聯絡窗口：新竹縣政府教育局青年事務科 </div><div> 連絡電話：<a href=\"tel:+886-03-5518101,2824\">03-5518101 #2864、2814、2834、2895、2893、2824</a></div></div><div class=\"footer-bottom-item fccs align-items-lg-start\"> TIME：每週一(Mon)~週五(Fri) 09:00-17:00<br>國定假日及特定假日除外。 </div><div class=\"footer-bottom-item social-group frcc justify-content-lg-start\"><a href=\"https://www.facebook.com/awesomehsinchu/\" class=\"social-group-item d-flex me-4\"><div class=\"icon-facebook w-100\"><span class=\"visually-hidden\">Facebook</span></div></a><a href=\"https://instagram.com/hsinchu_youth\" class=\"social-group-item d-flex me-4\"><div class=\"icon-instagram w-100\"><span class=\"visually-hidden\">Instagram</span></div></a></div></div><div class=\"frcc mb-4\"><a href=\"https://accessibility.moda.gov.tw/Applications/Detail?category=20240704093457\" title=\"無障礙網站\"><img src=\"resources/images/icon/icon-accessibility.png\" alt=\"通過A無障礙網頁檢測\"></a></div><div class=\"frcc policies\"> 本站採用 reCAPTCHA 保護機制 <a title=\"另開新視窗\" target=\"_blank\" href=\"https://policies.google.com/privacy\">隱私權</a> &amp; <a title=\"另開新視窗\" target=\"_blank\" href=\"https://policies.google.com/terms\">條款</a></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_progress_bar),
    _createElementVNode("header", null, [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            id: "gotocenter",
            tabindex: "1",
            to: "#main",
            class: "sr-only",
            title: "跳到主要內容",
            onClick: _ctx.handleGoToCenter
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 跳到主要內容 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/",
            class: "navbar-brand d-flex"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/sitemap"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("網站導覽")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/about"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("關於我們")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/aiot_accelerator",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/startup",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/startupHub",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("ul", _hoisted_20, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/resources",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21,
                        _hoisted_22
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/funds",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23,
                        _hoisted_24
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/startup_resources",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_27, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectTo('/list'))),
                  class: "nav-link dropdown-toggle",
                  href: "#",
                  role: "button",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, "活動消息"),
                _createElementVNode("ul", _hoisted_28, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/news",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29,
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/events",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31,
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/achievements",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33,
                        _hoisted_34
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("ul", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/qa",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_39,
                        _hoisted_40
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/appointment",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_41,
                        _hoisted_42
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _hoisted_43,
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
              class: "d-flex embed-form",
              role: "search"
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.keyword) = $event)),
                class: "form-control",
                type: "search",
                placeholder: "關鍵字搜尋",
                "aria-label": "Search"
              }, null, 512), [
                [_vModelText, _ctx.form.keyword]
              ]),
              _hoisted_44
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _hoisted_45,
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("ul", _hoisted_52, [
                  _createElementVNode("li", _hoisted_53, [
                    _createVNode(_component_router_link, {
                      to: "/about",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("認識平台")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_54, [
                    _createVNode(_component_router_link, {
                      to: "/sitemap",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("網站導覽")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("ul", _hoisted_57, [
                  _createElementVNode("li", _hoisted_58, [
                    _createVNode(_component_router_link, {
                      to: "/resources",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("政府資源總覽")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_59, [
                    _createVNode(_component_router_link, {
                      to: "/funds",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("資金快搜")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_60, [
                    _createVNode(_component_router_link, {
                      to: "/startup_resources",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新創夥伴快搜")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_61, [
                    _createVNode(_component_router_link, {
                      to: "/startup",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("青創基地")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_62, [
                    _createVNode(_component_router_link, {
                      to: "/aiot_accelerator",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("AIoT 加速器")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createElementVNode("ul", _hoisted_65, [
                  _createElementVNode("li", _hoisted_66, [
                    _createVNode(_component_router_link, {
                      to: "/news",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("創業新訊")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_67, [
                    _createVNode(_component_router_link, {
                      to: "/events",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("近期活動")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_68, [
                    _createVNode(_component_router_link, {
                      to: "/achievements",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("亮點成果")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("ul", _hoisted_71, [
                  _hoisted_72,
                  _createElementVNode("li", _hoisted_73, [
                    _createVNode(_component_router_link, {
                      to: "/qa",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("創業Q&A")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_74, [
                    _createVNode(_component_router_link, {
                      to: "/appointment",
                      class: "nav-link p-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("預約諮詢")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_75
        ]),
        _hoisted_76
      ])
    ])
  ], 64))
}